var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBandwith(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 16.6667H10.0083",
    stroke: "#00FFA3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 7.35004C3.95851 5.30023 6.92536 4.16699 10.0001 4.16699C13.0748 4.16699 16.0417 5.30023 18.3334 7.35004",
    stroke: "#00FFA3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 10.7159C5.72449 9.18899 7.81881 8.33374 10.0001 8.33374C12.1814 8.33374 14.2757 9.18899 15.8334 10.7159",
    stroke: "#00FFA3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08325 13.6908C7.86212 12.9274 8.90928 12.4998 9.99992 12.4998C11.0906 12.4998 12.1377 12.9274 12.9166 13.6908",
    stroke: "#00FFA3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBandwith);
export default __webpack_public_path__ + "static/media/bandwith.5f77565ee01af80acd33c76270a3ef02.svg";
export { ForwardRef as ReactComponent };